import React from "react"
import { COLORS } from "../../utilities/Constants"
import { generalStyles } from "../styles/styles"
import FileRenderer from "../others/FileRenderer"

// Sous-titre d'un groupe de documents (Carte grise / Photos), aligné sur le style
// des sous-sections de FileSection / VehiculeDocumentsV2.
const subGroupLabel = {
	fontSize: 11,
	fontWeight: 600,
	color: COLORS.textLight,
	letterSpacing: "0.08em",
	textTransform: "uppercase",
	marginBottom: 10,
}

const galleryRow = {
	display: "flex",
	flexWrap: "wrap",
	gap: 10,
	alignItems: "flex-start",
}

/**
 * Carte « Documents véhicule » (lecture seule) de la fiche atelier V2.
 *
 * Affiche la carte grise et les photos du véhicule sélectionné en réutilisant
 * `FileRenderer` (vignettes + viewer plein écran scrollable, PDF en nouvel onglet).
 * `canDelete={false}` → pas de suppression ici (gestion sur la fiche client).
 *
 * Deux `FileRenderer` distincts : la carte grise et les photos ne se mélangent pas
 * dans la navigation du viewer.
 *
 * À n'afficher que si le véhicule a au moins un document (voir `hasVehiculeDocs`
 * côté appelant) — le composant suppose `vehicule` non nul.
 */
const AtelierVehiculeDocumentsCardV2 = ({ vehicule }) => {
	const photos = (vehicule && vehicule.files) || []
	const carteGrise = (vehicule && vehicule.carte_grise) || {
		saved: false,
		url: "",
	}

	return (
		<div style={{ ...generalStyles.card, height: "100%" }}>
			<div style={generalStyles.cardTitle}>Documents véhicule</div>

			{carteGrise.saved && (
				<div style={{ marginBottom: photos.length ? 20 : 0 }}>
					<div style={subGroupLabel}>Carte grise</div>
					<div style={galleryRow}>
						<FileRenderer
							files={[
								{
									url: carteGrise.url,
									name: "Carte grise",
									saved: true,
								},
							]}
							canDelete={false}
						/>
					</div>
				</div>
			)}

			{photos.length > 0 && (
				<div>
					<div style={subGroupLabel}>Photos</div>
					<div style={galleryRow}>
						<FileRenderer files={photos} canDelete={false} />
					</div>
				</div>
			)}
		</div>
	)
}

export default AtelierVehiculeDocumentsCardV2
